var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact__name",class:_vm.directionNameClass},[_c('h3',[_vm._v(_vm._s(_vm.name))]),_c('h3',[_vm._v(_vm._s(_vm.patronicname))]),_c('h3',[_vm._v(_vm._s(_vm.surname))])])
}
var staticRenderFns = []

export { render, staticRenderFns }